module.exports = __webpack_public_path__ + "static/img/swissglas.f3e871f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/swissglas.png
// module id = 506
// module chunks = 1